import Swal from 'sweetalert2';

// Toast notification utility
export const showToast = (message, type = 'success', duration = 3000) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom',
    showConfirmButton: false,
    showCloseButton: true,
    timer: duration,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
    customClass: {
      popup: `custom-toast-popup custom-toast-${type}`,
      title: 'custom-toast-title',
      closeButton: 'custom-toast-close'
    }
  });

  const config = {
    icon: type,
    title: message
  };

  switch (type) {
    case 'success':
      config.iconColor = '#28a745';
      break;
    case 'error':
      config.iconColor = '#dc3545';
      break;
    case 'warning':
      config.iconColor = '#ffc107';
      break;
    case 'info':
      config.iconColor = '#17a2b8';
      break;
    default:
      config.iconColor = '#6c757d';
  }

  Toast.fire(config);
};

// Success toast
export const showSuccess = (message, duration = 3000) => {
  showToast(message, 'success', duration);
};

// Error toast
export const showError = (message, duration = 4000) => {
  showToast(message, 'error', duration);
};

// Warning toast
export const showWarning = (message, duration = 3000) => {
  showToast(message, 'warning', duration);
};

// Info toast
export const showInfo = (message, duration = 3000) => {
  showToast(message, 'info', duration);
};

// Confirmation dialog
export const showConfirm = (title, text, confirmButtonText = 'Yes', cancelButtonText = 'No') => {
  return Swal.fire({
    title: title,
    text: text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#dc3545',
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText
  });
};

// Loading dialog
export const showLoading = (title = 'Loading...') => {
  Swal.fire({
    title: title,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
};

// Close loading dialog
export const hideLoading = () => {
  Swal.close();
};
